import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAnimation, useSpring } from 'framer-motion';
import { StyledHero } from './styled';

import Illustration from './components/Illustration';
import OurStoryWave from './components/OurStoryWave';
import Platforms from './components/Platforms';

const Hero = ({ scrollToHomeCountry }) => {
  const [allAnimationsFinished, setAllAnimationsFinished] = useState(false);
  const isMounted = useRef();

  const roadX = useSpring(0, { damping: 300 });
  const roadY = useSpring(0);

  const ourStoryControls = useAnimation();
  const platformsControls = useAnimation();
  const birdControls = useAnimation();

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const onIllustrationAnimationFinished = async () => {
    await platformsControls.start('visible');

    if (isMounted.current) {
      setAllAnimationsFinished(true);
    }
  };

  return (
    <StyledHero>
      <Illustration
        allAnimationsFinished={allAnimationsFinished}
        onAnimationFinished={onIllustrationAnimationFinished}
        birdControls={birdControls}
        ourStoryControls={ourStoryControls}
        roadX={roadX}
        roadY={roadY}
      />

      <Platforms
        platformsControls={platformsControls}
        birdControls={birdControls}
        allAnimationsFinished={allAnimationsFinished}
        roadX={roadX}
        roadY={roadY}
      />

      <OurStoryWave
        ourStoryControls={ourStoryControls}
        scrollToHomeCountry={scrollToHomeCountry}
      />
    </StyledHero>
  );
};

Hero.propTypes = {
  scrollToHomeCountry: PropTypes.func
};

export default Hero;
